<template>
<div class="container">
    <div class="row align-items-center justify-content-center position-relative">
        <!-- Desktop Image -->
        <img :src="require('@/assets/grow-better/grow-better.webp')" class="banner-image desktop-banner w-100 d-none d-md-block my-4" alt="Grow Better | HotelKey" loading="eager"/>
        <!-- Mobile Image -->
        <img :src="require('@/assets/grow-better/grow-better-mobile-new.webp')" class="banner-image mobile-banner w-100 d-block d-md-none" alt="Grow Better | HotelKey " loading="eager"/>

        <!-- Text Content -->
        <div class="col-md-6 position-absolute text-white text-center">
            <h2 class="hk-heading">Grow Better With HotelKey</h2>
            <p class="hk-subbody">Make the first step towards a more efficient, flexible, guest-centric approach to hospitality.</p>
            <router-link :to="'/contact-team'" class="nav-link p-0">
                <button type="button" class="btn hk-btn-demo-main me-2" :to="'contact-team'">
                    {{ $t("hk_all_btn.demo_btn") }}
                    <img src="@/assets/common/arrow-circle-right.svg" alt="arrow-circle-right-svg" class="w-auto demo-svg"  />
                </button>
            </router-link>
        </div>
    </div>
</div>
</template>

<style scoped>
.hk-heading,
.hk-subbody {
    color: #fff;
}

.position-absolute {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

@media (min-width: 768px) {
    .position-absolute {
        left: auto;
        right: 0%;
        transform: translate(0, -50%);
    }
}
</style>
